export const firebaseConfig = {
    // apiKey: "AIzaSyDdQvtKvlsm2xFFRz17OAXG8gouoCpHSOc",
    // authDomain: "omnu-crew.firebaseapp.com",
    // databaseURL: "https://omnu-crew.firebaseio.com",
    // projectId: "omnu-crew",
    // storageBucket: "omnu-crew.appspot.com",
    // messagingSenderId: "849037054324",
    // appId: "1:849037054324:web:822ee370b40787d8dd9c21",
    apiKey: "AIzaSyAdC8ymcJP33j0VzJzXqaNxoGupzcKP6Xo",
    authDomain: "ommni-bfb4e.firebaseapp.com",
    projectId: "ommni-bfb4e",
    storageBucket: "ommni-bfb4e.firebasestorage.app",
    messagingSenderId: "17200978025",
    appId: "1:17200978025:web:99fe59c17e15bce9446af8",
    measurementId: "G-BQ869RBZTJ"
};

// -----------------------------//
// Production Configuration     //
//------------------------------//
// export const firebaseConfig = {
//     apiKey: "AIzaSyCxXD7k2GFEBjutdja7p6eBHDyebVWoDTo",
//     authDomain: "mnyhands-production.firebaseapp.com",
//     projectId: "mnyhands-production",
//     storageBucket: "mnyhands-production.appspot.com",
//     messagingSenderId: "880733365822",
//     appId: "1:880733365822:web:a7f4624c7c1164d273536f"
// };


// var firebaseConfig = {
//     apiKey: "AIzaSyDdQvtKvlsm2xFFRz17OAXG8gouoCpHSOc",
//     authDomain: "omnu-crew.firebaseapp.com",
//     databaseURL: "https://omnu-crew.firebaseio.com",
//     projectId: "omnu-crew",
//     storageBucket: "omnu-crew.appspot.com",
//     messagingSenderId: "849037054324",
//     appId: "1:849037054324:web:822ee370b40787d8dd9c21"
//   };
//   // Initialize Firebase
//   firebase.initializeApp(firebaseConfig);